var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container",class:{ fullscreen: _vm.fullscreen },style:({ width: _vm.containerWidth })},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}}),_vm._v(" "),_c('div',{staticClass:"editor-custom-btn-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }